var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.125 60C118.125 27.8906 92.1094 1.875 60 1.875C27.8906 1.875 1.875 27.8906 1.875 60C1.875 92.1094 27.8906 118.125 60 118.125C92.1094 118.125 118.125 92.1094 118.125 60ZM13.125 60C13.125 34.2188 33.9844 13.125 60 13.125C85.7812 13.125 106.875 34.2188 106.875 60C106.875 86.0156 85.7812 106.875 60 106.875C33.9844 106.875 13.125 86.0156 13.125 60ZM38.2031 58.125C37.0312 59.2969 37.0312 60.9375 38.2031 62.1094L67.0312 90.9375C68.2031 91.875 69.8438 91.875 71.0156 90.9375L76.1719 85.5469C77.3438 84.375 77.3438 82.7344 76.1719 81.5625L54.8438 60L76.1719 38.6719C77.3438 37.5 77.3438 35.625 76.1719 34.6875L71.0156 29.2969C69.8438 28.125 68.2031 28.125 67.0312 29.2969L38.2031 58.125Z",
    fill: "#CFD7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowLeft);
export default __webpack_public_path__ + "static/media/sidebar-arrow-left.332f92432b6ec794023972a1e5265929.svg";
export { ForwardRef as ReactComponent };